// WelcomeVideoOverlay.jsx
import React, { useEffect, useState } from "react";
import { X, PlayCircle } from "lucide-react";
import "./WelcomeVideoOverlay.css";

export default function WelcomeVideoOverlay({
  src,
  title,
  subtitle,
  storageKey,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!src) return;
    const seen = storageKey ? localStorage.getItem(storageKey) : null;
    if (!seen) setOpen(true);
  }, [src, storageKey]);

  if (!src || !open) return null;

  const isYouTube = /youtube\.com|youtu\.be/.test(src);
  const isVimeo = /vimeo\.com/.test(src);
  const isEmbed = isYouTube || isVimeo || /\/embed\//.test(src);

  const dismiss = () => {
    if (storageKey) localStorage.setItem(storageKey, "1");
    setOpen(false);
  };

  return (
    <div
      data-testid="welcome-video-overlay"
      className="welcomeOverlay"
      onClick={dismiss}
    >
      <div
        className="glass welcomeCard"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={dismiss}
          aria-label="Skip welcome video"
          data-testid="welcome-video-dismiss"
          className="welcomeDismissBtn"
        >
          <X size={16} />
        </button>

        <div className="welcomeVideoWrap">
          {isEmbed ? (
            <iframe
              src={src + (src.includes("?") ? "&" : "?") + "autoplay=1"}
              title={title || "Welcome"}
              className="welcomeIframe"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video
              src={src}
              autoPlay
              controls
              playsInline
              className="welcomeIframe"
            />
          )}
        </div>

        <div className="welcomeFooter">
          <div className="welcomeFooterInfo">
            <p className="overline welcomeFooterOverline">
              <PlayCircle size={11} /> Welcome
            </p>
            {title && <h3 className="welcomeFooterTitle">{title}</h3>}
            {subtitle && (
              <p className="welcomeFooterSubtitle">{subtitle}</p>
            )}
          </div>
          <button
            onClick={dismiss}
            data-testid="welcome-video-skip"
            className="welcomeSkipBtn"
          >
            Skip →
          </button>
        </div>
      </div>
    </div>
  );
}